<template>
  <BModal
    id="main-guest-prod-inst-image-display-modal"
    ref="mainGuestProdInstImageDisplayModal"
    v-model="isVisible"
    no-header
    no-footer
    :no-close-on-backdrop="true"
    @hidden="onModalHidden"
  >
    <BOverlay :show="overlayShow" rounded="sm">
      <div class="d-flex justify-content-end">
        <button type="button" class="btn-close" aria-label="Close" @click="hideModal()" />
      </div>
      <div class="text-start">
        <h5>スペック決定した商品の画像制作指示表示</h5>
      </div>
      <div class="p-0 row ms-5 mt-3" v-if="!overlayShow">
        <div class="col-12 row mt-2" v-for="imageIndex in 5" :key="imageIndex">
          <div class="col-1"></div>
          <div :class="mainGuestProdInstImageDisplayData[`image${imageIndex}`]['hasImage'] ? 'col-9' : 'col-9 text-black-50'">
            {{ getImageLabel(imageIndex) }}
          </div>
          <div class="col-1 text-center">
            <BFormCheckbox
              v-if="mainGuestProdInstImageDisplayData[`image${imageIndex}`]['hasImage']"
              :id="`image${imageIndex}`"
              v-model="mainGuestProdInstImageDisplayData[`image${imageIndex}`]['display']"
              switch
              class="toggle-display-image"
            />
          </div>
        </div>
      </div>
    </BOverlay>
  </BModal>
</template>
<script>
import { BModal, BOverlay, BButton, BFormCheckbox } from 'bootstrap-vue-next'
import CommonModal from '@/components/CommonModal'

export default {
  name: 'MainGuestProdInstImageDisplayModal',
  components: {
    BModal,
    BOverlay,
    BButton,
    BFormCheckbox,
    CommonModal
  },
  props: {
    mainGuestProdInstImageDisplayData: {
      type: Object,
      require: true
    }
  },
  emits: ['setMainGuestProdInstImageDisplayData'],
  data () {
    return {
      isVisible: false,
      overlayShow: false
    }
  },
  methods: {
    showModal () {
      this.isVisible = true
    },
    hideModal () {
      this.isVisible = false
    },
    onModalHidden () {
      this.$emit('setMainGuestProdInstImageDisplayData', this.mainGuestProdInstImageDisplayData)
    },
    getImageLabel (index) {
      const labels = {
        1: '１:中景',
        2: '２:メインテーブル',
        3: '３:ゲストテーブル(横長)',
        4: '４:ゲストテーブル(縦長)',
        5: '５:花合わせ'
      }
      return labels[index]
    }
  }
}
</script>
<style>
</style>
